// Cookie-Helpers für Client + Server.
// Server-Read liegt im Express-Middleware-Layer (server/index.js),
// Client-Read/Write ist hier.

export function readCookie(name: string): string | null {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(
    new RegExp("(?:^|; )" + name.replace(/[.$?*|{}()[\]\\/+^]/g, "\\$&") + "=([^;]*)"),
  );
  return match ? decodeURIComponent(match[1]) : null;
}

export function writeCookie(
  name: string,
  value: string,
  { days = 365, sameSite = "lax" }: { days?: number; sameSite?: "lax" | "strict" } = {},
): void {
  if (typeof document === "undefined") return;
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; samesite=${sameSite}`;
}

export const COOKIE_VARIANT = "scrolly_variant";
